import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { forkJoin } from 'rxjs';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';
import { RetailerService } from '../../retailer.service';

@Component({
  selector: 'app-manage-retailer-smart',
  template: `<app-edit-retailer [salesReps]='salesReps' [RetailerId]='retailerId' [businessTypes]='businessTypes' [pricelists]='pricelists' [retailerDetails]='retailerDetails' [allLinkableRetailers]="allLinkableRetailers" [currentLinkedRetailers]="currentLinkedRetailers"></app-edit-retailer>`,
  styles: [
  ]
})
export class EditRetailerSmartComponent extends FeaturesBaseComponent implements OnInit {
  configValues;
  salesReps;
  businessTypes;
  pricelists;
  retailerDetails;
  retailerId: any;
  allLinkableRetailers: any = [];
  currentLinkedRetailers: any= [];

  constructor(private retailerService: RetailerService, private activeRoute:ActivatedRoute, private router: Router) {
    super();
    this.retailerId = this.activeRoute.snapshot.params.retailerId;
    
    this.getDropDownValues();

  }

  ngOnInit(): void {
    super.ngOnInit();

  }

  getDropDownValues() {

    let salesRepsBehavior = this.retailerService.getActiveSalesRepresentatives();
    let businessTypeBehavior = this.retailerService.getConfigValues();
    let pricelistsBehavior = this.retailerService.getActivePricelists();
    let allLinkedRetailers = this.retailerService.getAllRetailerAccounts();
    let currentLinkedRetailers = this.retailerService.getRetailersLinkedById(this.retailerId);
    let retailerDetails = this.retailerService.getSelectedRetailer(this.retailerId);
    
    this.salesReps = [];
    forkJoin([salesRepsBehavior, businessTypeBehavior, pricelistsBehavior, allLinkedRetailers, currentLinkedRetailers, retailerDetails ]).subscribe(results => {
      let _salesReps: any = results[0];
      this.salesReps = _salesReps.data;
      let _businessTypes: any = results[1];
      this.businessTypes = _businessTypes.data;
      let _priceList: any = results[2];
      this.pricelists = _priceList.data;
      this.allLinkableRetailers = results[3]['data']
      this.currentLinkedRetailers = results[4]['data']
      this.retailerDetails = results[5]['data']
      if(results[5].httpcode == 200){
            this.salesRepPricelist();        
      }
    })
  }
  salesRepPricelist(){
   
   
    let _salesrep = this.retailerDetails?.saleRepUserId;
    let params: any = {
      salesRepId:_salesrep
    }
    this.retailerService.getPricelists(params).subscribe(
      res => {
        let data: any = res;
        if (data.httpcode == 200) {
          this.pricelists = data.data;
          
        }
      });
  }  
  private initForm() {
  }
}
